/**
 * Auth Utility Module
 *
 * Centralized token access for all HTTP clients (axios and fetch).
 * Ensures consistent authentication across all API calls.
 */

import { useAuthStore } from '@/stores/authStore';

/**
 * Get the current authentication token from the store
 * @returns JWT token or null if not authenticated
 */
export function getAuthToken(): string | null {
  return useAuthStore.getState().token;
}

/**
 * Get authentication headers for fetch() calls
 * @returns Headers object with Authorization if token exists
 */
export function getAuthHeaders(): HeadersInit {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/**
 * Add authentication header to an existing headers object
 * @param headers - Existing headers object to modify
 */
export function addAuthHeader(headers: Record<string, string>): void {
  const token = getAuthToken();
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
}
